// extracted by mini-css-extract-plugin
export default {"locaiscontainer":"Contato_locaiscontainer__ZyOS-","locaisinfo":"Contato_locaisinfo__DwIPi","btn":"Contato_btn__r3NFR","maps":"Contato_maps__DAMA+"};